import React, { useRef, useState, useEffect } from 'react';

const CellWithTooltip = ({ children }) => {
  const contentRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const element = contentRef.current;
      if (!element) return;
      const overflow = element.scrollWidth > element.clientWidth;
      setIsOverflowing(overflow);
      // Set the title attribute to the text content of the element if overflowing
      if (overflow) {
        element.setAttribute('title', element.textContent);
      } else {
        element.removeAttribute('title');
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    return () => window.removeEventListener('resize', checkOverflow);
  }, [children]);

  return (
    <div
      ref={contentRef}
      className="content-wrapper"
    >
      {children}
    </div>
  );
};

export default CellWithTooltip;
